<div class="badges-wrapper flex flex-col flex-wrap gap-1">
  <div class="top-section flex flex-col">
    <div class="system-status-row flex flex-row flex-wrap gap-1">
      <app-pill
        *ngIf="installation.isSystemLocked"
        data-at-status-pill
        [type]="pillType.errorInverted"
      >
        {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.COLD_SYSTEM' | translate }}
      </app-pill>
      <app-pill
        *ngIf="
          isShowingAggregatedStatus && installation.aggregatedStatus
            | aggregatedStatusPill as aggregatedStatusPill
        "
        [type]="aggregatedStatusPill.pillType"
      >
        {{ aggregatedStatusPill.label | translate }}
      </app-pill>
    </div>
  </div>

  <div
    class="error-codes-row flex flex-row flex-wrap gap-1"
    *ngIf="kanbanBoardHelperService.isErrorSmartNote(mainDevice?.smartNotes)"
  >
    <app-pill [type]="pillType.error" *ngFor="let errorCode of errorCodes | slice: 0:3">
      {{ errorCode }}
    </app-pill>
    <app-pill
      *ngIf="errorCodes.length > 3"
      [type]="pillType.error"
      data-at-status-pill
      matTooltip="{{ 'INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_ERROR_INFO' | translate }}"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.TOOLTIP.SHOW_MORE_TXT' | translate }}
    </app-pill>
  </div>

  <div class="bottom-section flex flex-row flex-wrap gap-1">
    <ng-container *ngIf="isSingleDevice">
      <div
        class="w-full flex flex-wrap gap-1"
        *ngIf="mainDevice | dashboardAnomalyPill as anomalyPills"
      >
        <app-pill
          *ngFor="let pill of anomalyPills"
          [type]="pill.pillType"
          [matTooltip]="pill.tooltipText"
        >
          {{ pill.label }}
        </app-pill>
      </div>

      <app-pill
        *ngIf="mainDevice | dashboardOperatingMode as operatingModes"
        [type]="pillType.neutral"
      >
        {{ operatingModes }}
      </app-pill>
    </ng-container>
    <app-pill [type]="pillType.neutralInverted">
      <ng-container *ngIf="installation.installationType === installationType.Residential">
        {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.RESIDENTIAL' | translate }}
      </ng-container>
      <ng-container *ngIf="installation.installationType === installationType.Commercial">
        {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.COMMERCIAL' | translate }}
      </ng-container>
    </app-pill>
    <mat-icon
      *ngIf="showDuplicationIcon"
      class="duplicate-icon"
      [matTooltip]="'+INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_COPY_INFO' | translate"
      matTooltipPosition="above"
      >link</mat-icon
    >
  </div>
</div>
